import { useEffect, useState } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoClose } from "react-icons/io5";
import { MdOutlinePowerSettingsNew } from "react-icons/md";
import { signOut } from "firebase/auth";
import pokeballIcon from "../assets/pokeball-icon.png";
import { Link, useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { setToast, setUserStatus } from "../app/slices/AppSlice";
import { addListToDatabase } from "../app/reducers/addListToDatabase";
import { clearUserPokemons } from "../app/slices/PokemonSlice";
import { firebaseAuth } from "../utils/firebaseConfig";

const navigationRoutes = [
  { name: "Search", route: "/search" },
  { name: "Compare", route: "/compare" },
  { name: "Pokemon", route: "/pokemon" },
  { name: "My List", route: "/list" },
  { name: "About", route: "/about" },
];

export default function Navbar() {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const userInfo = useAppSelector(({ app }) => app.userInfo);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const index = navigationRoutes.findIndex(({ route }) =>
      location.pathname.includes(route)
    );
    const underlines = document.querySelectorAll<HTMLElement>(".underline");
    underlines.forEach((u) => {
      u.style.transform = `translate3d(${index * 100}%,0,0)`;
    });
    setIsOpen(false);
  }, [location.pathname]);

  const logOutUser = async () => {
    await dispatch(addListToDatabase());
    await signOut(firebaseAuth);
    dispatch(setUserStatus(undefined));
    dispatch(clearUserPokemons());
    dispatch(setToast("Logged out"));
  };

  return (
    <nav className={isOpen ? "is-open" : ""}>
      <div className="block">
        <Link to="/search" className="nav-logo" aria-label="Home">
          <img src={pokeballIcon} alt="" />
        </Link>
      </div>
      <div className="data">
        <ul>
          <div className="underline"></div>
          <div className="underline"></div>
          <div className="underline"></div>
          {navigationRoutes.map(({ name, route }, index) => (
            <Link to={route} key={index} onClick={() => setIsOpen(false)}>
              <li>{name}</li>
            </Link>
          ))}
        </ul>
      </div>
      <div className="block block--actions">
        {userInfo && (
          <button
            type="button"
            className="nav-icon-btn nav-logout-btn"
            aria-label="Sign out"
            title="Sign out"
            onClick={logOutUser}
          >
            <MdOutlinePowerSettingsNew />
          </button>
        )}
        <button
          type="button"
          className="nav-icon-btn nav-menu-btn"
          aria-label={isOpen ? "Close menu" : "Open menu"}
          aria-expanded={isOpen}
          onClick={() => setIsOpen((v) => !v)}
        >
          {isOpen ? <IoClose /> : <GiHamburgerMenu />}
        </button>
      </div>
    </nav>
  );
}
